import fetcher from '@/repositories/fetcher';
import { getHeadersWithBasicAuth } from '@/repositories/utils';
import type { BaseResponseApi } from '@/types/general/responseApi';

import type { ResponseVerifyOtp, VerifyOtpBody } from './types';

export const verifyLoginOtp = async (body: VerifyOtpBody): Promise<BaseResponseApi<ResponseVerifyOtp>> => {
  const data = await fetcher<BaseResponseApi<ResponseVerifyOtp>>({
    method: 'POST',
    url: '/api/auth/login',
    body,
    headers: getHeadersWithBasicAuth()
  });

  return data;
};

export const verifyRegisterOtp = async (body: VerifyOtpBody): Promise<BaseResponseApi<ResponseVerifyOtp>> => {
  const data = await fetcher<BaseResponseApi<ResponseVerifyOtp>>({
    method: 'POST',
    url: '/api/auth/register',
    body,
    headers: getHeadersWithBasicAuth()
  });

  return data;
};
